import { Inject, Injectable } from '@angular/core';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';

@Injectable({ providedIn: 'root' })
export class MeldungService {
    constructor(
        private api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    public jetztAlleMeldungenSenden() {
        return this.api.post(this.apiBaseUrl + 'meldung/anstossen.php', {}, null);
    }
}
